import packageJson from '../../package.json'

// export const DOMAIN = ''
export const DOMAIN = Boolean(
  window.location.host.includes('192.168.') ||
    window.location.host.includes('localhost')
)
  ? packageJson.proxy
  : '';

const WP_BASE_PATH = '/wp-json/smk/v1'

export const WP_BASE_API = `${DOMAIN}${WP_BASE_PATH}`;

export const getPageData = (pathname, searchQuery) => {
  // EXAMPLE: http://smk.dk.headtest.dk/wp-json/smk/v1/pages?path=/en/article/nu-med-iiif
  const langCode = pathname && pathname.slice(0, 4) === '/en/' ? '/en' : ''
  const searchQueryAnd = searchQuery.replace('?', '&');
  return fetch(`${DOMAIN}${langCode}${WP_BASE_PATH}/pages?path=${pathname}${searchQueryAnd}`, {
    method: 'get'
  })
    .then(response => {
      return response.text().then(string => {
        string = string.substr(string.indexOf('{'));
        return JSON.parse(string);
      });
    })
    .catch(error => {
      console.error('getPageData > Error', error);
      return null;
    });
};

export const getSuggestions = (searchTerm, langCode) => {
  return fetch(
    `${WP_BASE_API}/suggest?s=${encodeURIComponent(
      searchTerm.toLowerCase()
    )}&lang_code=${langCode}`,
    {
      method: 'get'
    }
  )
    .then(response => response.json())
    .catch(error => {
      console.error('getSuggestions > Error', error);
      return null;
    });
};



// WEBPACK FOOTER //
// ./src/services/service-wp.js